module.exports = __webpack_public_path__ + "static/img/SketchPng1c913217c56f7ec3dd0fa1c4585999725eb6c225f6fed52d5ede028cdde1afd3.c4e71a33.png";